import React from "react";

/**
 * My Account summary stat card — Figma node 1-9171
 */
export function AccountKpiCard({ title, value, variant = "default" }) {
  return (
    <div
      className={`my-account-kpi-card${
        variant === "warning" ? " my-account-kpi-card--warning" : ""
      }${typeof value === "string" ? " my-account-kpi-card--text-value" : ""}`}
    >
      <span className="my-account-kpi-card__label">{title}</span>
      <span className="my-account-kpi-card__value">{value}</span>
    </div>
  );
}

export default AccountKpiCard;
